import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifyPasscodeRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifyPasscodeResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifyPasscode = (request: VerifyPasscodeRequest, options?: CashRequestOptions) =>
  post<VerifyPasscodeRequest, VerifyPasscodeResponse>('/2.0/cash/verify-passcode', request, {
    ...options,
    rejectOnError: true,
  })
